angular
    .module("multicrm", [
            'dashboard',
            'comment',
            'clients',
            'note',
            'sorting',
            'files',
            'offers',
            'tasks',
            'tasks.meeting-attendance',
            'account',
            'auth',
            'shared-calendar',
            'task-auto-closer',
            'navbars',
            'egg.order',
            'egg.delivery',
            'invoice',
            'project',
            'assets',
            'lead',
            'lead.activity',
            'clients.finder',
            'service-request',
            'property',
            'property-price-list',
            'property-deal',
            'agreements',
            'vehicle-location',
            'vehicle',
            'vehicle-booking',
            'device-management',
            'rental',
            'todo',
            'leave',
            'manufacturing',
            'workflow',
            'businessThread',
            'powerOfAttorney'
        ]
    )
    .config(function ($httpProvider) {
        $httpProvider.interceptors.push('appVersionInterceptor');
    })
    .factory('appVersionInterceptor', function (toastr, VERSION) {
        return {
            'response': function (response) {
                let appVersion = response.headers('X-APP-VERSION');
                if (appVersion !== null && appVersion !== VERSION && toastr.active() === 0) {
                    let toastrConf = {
                        preventDuplicates: true,
                        preventOpenDuplicates: true,
                        timeOut: 0,
                        extendedTimeOut: 0
                    };
                    toastr.warning('Odśwież stronę przeglądarki aby załadować nową wersję', "Nowa wersja aplikacji!", toastrConf);
                }
                return response;
            }
        }
    })

    .directive('autoDropdown', function($window, $timeout) {
        return {
            restrict: 'A',
            scope: {
                isOpen: '='
            },
            link: function(scope, element) {

                const dropdownMenu = element.find('.dropdown-menu');

                const calculateDropdownPosition = () => {
                    const buttonRect = element[0].getBoundingClientRect();
                    const windowHeight = $window.innerHeight;
                    const dropdownHeight = dropdownMenu[0].offsetHeight;

                    const spaceAbove = buttonRect.top;
                    const spaceBelow = windowHeight - buttonRect.bottom;

                    const scrollY = $window.scrollY || $window.pageYOffset;
                    const scrollX = $window.scrollX || $window.pageXOffset;

                    if(spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
                        dropdownMenu.css({
                            // 'position': 'fixed',
                            'top': scrollY + buttonRect.top - dropdownHeight + 'px',
                            'bottom': 'auto',
                            // 'left': buttonRect.left + 'px'
                        });
                    }

                    if(buttonRect.right + dropdownMenu[0].offsetWidth > $window.innerWidth) {
                        dropdownMenu.css({
                            'right': '5px',
                            'left': 'auto'
                        });
                    }
                };

                scope.$watch('isOpen', isOpen => {
                    if (isOpen) {
                        dropdownMenu.css('visibility', 'hidden');
                        $timeout(() => {
                            calculateDropdownPosition();
                            dropdownMenu.css('visibility', 'visible');
                        }, 0);
                    }
                    else {
                        dropdownMenu.css({'visibility': '', 'top': '', 'left': ''});
                    }
                });

                angular.element($window).on('resize', calculateDropdownPosition);

                scope.$on('$destroy', () => {
                    angular.element($window).off('resize', calculateDropdownPosition);
                });
            }
        };
    })
